export default "__VITE_ASSET__CWwaZkWg__"